export default __webpack_public_path__ + "static/media/ic_svc_chat_together_beta.4c0a039a.png";